import React, { useState } from 'react';
import { createGondolaPromotionsService } from 'services/category.service';

interface NewCategory {
    id: string;
    enabled: boolean;
    name: string;
    icon?: string;
    position: number;
    required?: boolean;
}

interface NewCategoriaModalProps {
    uid: string;
    type: 'Góndola y frío' | 'Promociones';
    onClose: () => void;
    onCategoryCreated: () => void;
}

export default function NewCategoriaModal({ uid, type, onClose, onCategoryCreated }: NewCategoriaModalProps) {
    const [formData, setFormData] = useState<NewCategory>({
        id: '',
        enabled: false,
        name: '',
        icon: '',
        position: null as unknown as number,
        required: false,
    });
    const [imageBase64, setImageBase64] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type, checked } = e.target as HTMLInputElement;
        console.log(imageBase64)

        if (name === 'position') {
            // Permitir dígitos, longitud máxima de 2
            if (/^\d{0,2}$/.test(value)) {
                setFormData({
                    ...formData,
                    position: value === '' ? null as unknown as number : Number(value),
                });
            }
            return;
        }

        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result as string;
                setImageBase64(base64String);
                setFormData({
                    ...formData,
                    icon: base64String,
                });
            };
            reader.readAsDataURL(file);
        }
    };


    const handleSave = async () => {
        if (!formData.name.trim()) {
            alert('El nombre de la categoría es obligatorio.');
            return;
        }

        const newCategory = {
            ...formData,
            typeCategory: type === 'Góndola y frío' ? 'gondolaandcold' as 'gondolaandcold' : 'promotions' as 'promotions',
        };

        try {
            const response = await createGondolaPromotionsService(uid, newCategory);
            if (response) {
                //console.log('Nueva categoría creada:', response);
                alert('Categoría creada exitosamente.');
                onCategoryCreated();
                onClose();
            } else {
                //console.error('Error al crear la nueva categoría.');
            }
        } catch (error) {
            //console.error('Error en el servicio de creación:', error);
        }
    };

    return (
        <div className="modal ">
            <div className="modal-content xl:w-3/5">
                <h2 className="text-xl text-white font-semibold mb-5 w-full border-b-2 p-5 bg-primary rounded-t-lg">
                    Crear Nueva Categoría {type}
                </h2>
                <form className="p-5">
                    <div className='flex flex-row justify-between mb-5 gap-x-10'>
                        <div className='flex flex-col w-full'>
                            <div className="mb-5">
                                <label>ID:</label>
                                <input
                                    className="inputFormCat"
                                    type="text"
                                    name="id"
                                    value={formData.id}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className='flex '>
                            <label>Inactiva</label>
                            <div
                                className={`toggle mx-4 ${formData.enabled ? 'enabled' : 'disabled'}`}
                                onClick={() =>
                                    setFormData({
                                        ...formData,
                                        enabled: !formData.enabled,
                                    })
                                }
                            >
                                <div className="toggle-circle"></div>
                            </div>
                            <label>Activa</label>
                        </div>

                    </div>
                    {/* Nombre */}
                    <div className="mb-5">
                        <label>Nombre:</label>
                        <input
                            className="inputFormCat"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Icono */}
                    <div className="mb-5">
                        <label>Icono:</label>
                        <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={handleImageChange}
                            className="border p-2"
                        />
                    </div>

                    {/* Posición */}
                    <div className="mb-5">
                        <label>Posición:</label>
                        <input
                            className="inputFormCat"
                            type="text"
                            name="position"
                            inputMode="numeric"
                            value={formData.position === null ? '' : formData.position.toString()}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Estado */}
                    {/* <div className="flex items-center mb-5">
                        <label>Estado:</label>
                        <div
                            className={`toggle mx-4 ${formData.enabled ? 'enabled' : 'disabled'}`}
                            onClick={() =>
                                setFormData({
                                    ...formData,
                                    enabled: !formData.enabled,
                                })
                            }
                        >
                            <div className="toggle-circle"></div>
                        </div>
                        <span>{formData.enabled ? 'Activa' : 'Inactiva'}</span>
                    </div> */}

                    {/* Botones */}
                    <div className="modal-actions">
                        <button
                            type="button"
                            className="buttonGuardarModalSave"
                            onClick={handleSave}
                        >
                            Guardar
                        </button>
                        <button
                            type="button"
                            className="buttonGuardarModalCancel"
                            onClick={onClose}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}